import { useCallback } from "react";
import { surveyAPI } from "services/swagger-api/surveyApi";
import { SurveyFormValues } from "../form/SurveyFormValues";

export const useSurveyForm = () => {

  const createSurvey = useCallback(
    async (values: SurveyFormValues) => {
      return await surveyAPI.createQuestionnaire({
        createSurveyCommandDto: {
          name: values.name,
          code: values.code,
          contextId: values.contextId,
          branchId: values.branchId || undefined,
          description: values.description || undefined
        }
      });
    },
    []
  );

  const updateSurvey = useCallback(
    async (values: SurveyFormValues, surveyId?: string) => {
      if (!surveyId) {
        throw new Error('Survey ID is required for update');
      }
      return await surveyAPI.updateSurvey({
        id: surveyId,
        updateSurveyCommandDto: {
          name: values.name,
          contextId: values.contextId,
          branchId: values.branchId || undefined,
          description: values.description || undefined,
          isActive: values.isActive
        }
      });
    },
    []
  );

  const deleteSurvey = useCallback(
    async (surveyId: string) => {
      return await surveyAPI.deleteSurvey({ id: surveyId });
    },
    []
  );

  return {
    createSurvey,
    updateSurvey,
    deleteSurvey
  };
};
